<template>
  <div
    :class="[
      $style.base,
      {
        [$style.smallScreen]: $screen === 's',
        [$style.mediumScreen]: $screen === 'm'
      }
    ]"
  >
    <div :class="$style.nav">
      <Nav
        :navItems="navItems"
        v-test="'settings-nav'"
      />
    </div>
    <div
      ref="scrollContainer"
      :class="$style.content"
      v-test="'admin-scroll-container'"
    >
      <div :class="$style.contentInner">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'SettingsBase',
};
</script>

<script
  setup
  lang="ts"
>
import { usePageScroll } from '@/helpers/scroll';
import { usePageLayoutStore } from '@/stores/page-layout';
import Nav from './Nav.vue';

defineProps<{
  navItems: {
    groups: {
      name: string;
      label: string;
    }[];
    items: {
      name: string;
      label: string;
      group: string;
      show: boolean;
    }[];
  };
}>();

const scrollContainer = ref();
const { screenSize } = usePageLayoutStore();

usePageScroll(screenSize === 's' ? undefined : scrollContainer);
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  height: 100%;
  border-top: 1px solid var(--color-border);
  background-color: var(--color-bg);
}

$navWidth: 200px;

.nav {
  .base:not(.smallScreen) & {
    width: $navWidth;
    height: 100%;
    border-right: 1px solid var(--color-border);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .base.smallScreen & {
    position: absolute;
    top: $header-height;
    left: 0;
    width: 100%;
    z-index: 5;
    background-color: var(--color-bg);
    overflow: hidden;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
  }
}

.content {
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: var(--color-bg-secondary);

  .base:not(.smallScreen) & {
    height: 100%;
    width: calc(100% - #{$navWidth});
    overflow-y: auto;
  }

  .base.smallScreen & {
    width: 100%;
    padding-top: 52px; // Mobile subnav height
    z-index: 1;
  }
}

.contentInner {
  .base:not(.smallScreen) & { 
    height: 100%;
  }
}
</style>
